import { Translation } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const fetchAvailableTranslationsForReference = async () => {
  const response = await axiosInstance.get<ApiResponse<Translation[]>>("/api/translation/available-for-reference");
  return response.data.data;
};
